import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { BeforeAfter } from './components/BeforeAfter';
import { DecisionMap } from './components/DecisionMap';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { WorkflowExample } from './components/WorkflowExample';
import { Audience } from './components/Audience';
import { Author } from './components/Author';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ivory pb-24 font-sans text-ink" data-id="element-0" data-mp="23ujkecdc1n3i">
      <MetaPixel data-id="element-1" data-mp="3iiwg8rrbto4t" />
      <Hero data-id="element-2" data-mp="3ijfunyhrpue3" />
      <main data-id="element-3" data-mp="3ihv2gfixenje">
        <ProblemSection data-id="element-4" data-mp="3ii4qhxkeukmg" />
        <BeforeAfter data-id="element-5" data-mp="3ml1397n9rmih" />
        <DecisionMap data-id="element-6" data-mp="3mkhou0wtvg97" />
        <Volumes data-id="element-7" data-mp="3mjq27fl7ksv2" />
        <Bonuses data-id="element-8" data-mp="3mj6hjr46bqdc" />
        <WorkflowExample data-id="element-9" data-mp="3rcj6y3gog175" />
        <Audience data-id="element-10" data-mp="3rdaqgfx028h2" />
        <Author data-id="element-11" data-mp="3rcsy3udgkeef" />
        <Testimonials data-id="element-12" data-mp="3recerm310rgq" />
        <Offer data-id="element-13" data-mp="5yi8qe3h5da" />
        <Guarantee data-id="element-14" data-mp="6hr7hlrojf6" />
        <FAQ data-id="element-15" data-mp="4wx1t3d72hu" />
        <FinalCTA data-id="element-16" data-mp="5gel8p3rovc" />
      </main>
      <footer className="w-full bg-navy-950 px-5 py-10 text-center text-sm text-navy-100/70" data-id="element-17" data-mp="7ssnarqpf34">
        <p className="mx-auto max-w-2xl" data-id="element-18" data-mp="2zng1ikd20ksx">
          Professional educational resource. Not a substitute for individualized clinical assessment,
          diagnosis, or treatment.
        </p>
        <p className="mt-3" data-id="element-19" data-mp="38nunzn1r85y0">© 2026 Dental Veneer Complications Blueprint™ · Dr. Sarah Collins</p>
      </footer>
      <FloatingCTA data-id="element-20" data-mp="3dii530ufhy2k" />
      <PurchasePopup data-id="element-21" data-mp="nvstj3irmlvf" />
    </div>;
}